const PREFIX = '#reaction-';

export function getReactionIdFromUrlHash(hash: string) {
  return typeof hash === 'string' && hash.startsWith(PREFIX)
    ? hash.slice(PREFIX.length)
    : null;
}

export default function reactionThreadHash(threadId: string) {
  return `${PREFIX}${threadId}`;
}
